import MuiCheckbox, { CheckboxProps } from '@mui/material/Checkbox';

export const Checkbox = (props: CheckboxProps) => {
  return (
    <MuiCheckbox
      {...props}
      sx={{ ...props?.sx, ...{ '@media print': { display: 'none' } } }}
    />
  );
};
